import { render, staticRenderFns } from "./Table.global.vue?vue&type=template&id=d64bec1e&scoped=true&lang=pug&"
import script from "./Table.global.vue?vue&type=script&lang=ts&"
export * from "./Table.global.vue?vue&type=script&lang=ts&"
import style0 from "./Table.global.vue?vue&type=style&index=0&id=d64bec1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64bec1e",
  null
  
)

export default component.exports